import type { Channel } from '@/types';

/** Application / posting channels shown in recruiter UI (includes Internal). */
export const APPLICATION_SOURCES: Channel[] = [
  'LinkedIn',
  'Company Website',
  'Indeed',
  'Glassdoor',
  'InfoJobs',
  'Referral',
  'Internal',
  'Other',
];

export const CHANNEL_TO_BACKEND: Record<string, string> = {
  LinkedIn: 'linkedin',
  'Company Website': 'company_website',
  Indeed: 'indeed',
  Glassdoor: 'glassdoor',
  InfoJobs: 'infojobs',
  Referral: 'referral',
  Internal: 'internal',
  Other: 'other',
};

export const CHANNEL_FROM_BACKEND: Record<string, Channel> = {
  linkedin: 'LinkedIn',
  company_website: 'Company Website',
  indeed: 'Indeed',
  glassdoor: 'Glassdoor',
  infojobs: 'InfoJobs',
  referral: 'Referral',
  internal: 'Internal',
  other: 'Other',
};

export function channelToBackend(ch: string): string {
  return CHANNEL_TO_BACKEND[ch] ?? ch.toLowerCase().replace(/\s+/g, '_');
}

export function channelFromBackend(ch: string): Channel {
  return CHANNEL_FROM_BACKEND[ch] ?? 'Other';
}
